var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalexpertise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-13);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9.76,
    y1: 18.68,
    x2: 11.48,
    y2: 18.68,
    gradientTransform: "translate(0 26) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0067bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000c55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 12.52,
    y1: 21.85,
    x2: 13.96,
    y2: 21.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 7.51,
    y1: 18.63,
    x2: 8.76,
    y2: 18.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 14.43,
    y1: 21.56,
    x2: 15.91,
    y2: 21.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.79,
    y1: 3.57,
    x2: 23.21,
    y2: 3.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 4.03,
    y1: 12.02,
    x2: 19.97,
    y2: 12.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 10.04,
    y1: 21.85,
    y2: 21.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 15.24,
    y1: 18.63,
    x2: 16.49,
    y2: 18.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 8.09,
    y1: 21.56,
    x2: 9.57,
    y2: 21.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 10.04,
    y1: 15.46,
    y2: 15.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 14.43,
    y1: 15.74,
    x2: 15.91,
    y2: 15.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1.93,
    y1: 12.02,
    x2: 22.07,
    y2: 12.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 5.42,
    y1: 17.91,
    x2: 18.58,
    y2: 17.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 12.52,
    y1: 18.65,
    x2: 14.24,
    y2: 18.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 12.52,
    y1: 15.46,
    x2: 13.96,
    y2: 15.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 8.09,
    y1: 15.74,
    x2: 9.57,
    y2: 15.74,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M11.48,6.27h-1.62c-.05,.33-.1,.72-.1,1.05,0,.38,.05,.72,.1,1.05h1.62v-2.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.52,3.08v2.15h1.43c-.33-1.1-.86-1.86-1.43-2.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M8.71,7.37c0-.38,0-.72,.05-1.05h-1.1c-.1,.33-.14,.72-.14,1.05,0,.38,.05,.72,.14,1.05h1.1c0-.33-.05-.72-.05-1.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M15.05,5.22h.86c-.33-.67-.86-1.19-1.48-1.57,.24,.48,.48,1,.62,1.57Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23.12,21.64H.79c.24,.91,1.05,1.57,2.05,1.57H21.16c1,0,1.81-.67,2.05-1.57h-.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.03,18.49h15.94V9.47h-.62v.05c0,.1-.05,.14-.1,.24s-.05,.19-.1,.24c-.05,.1-.05,.14-.1,.24s-.05,.14-.1,.24-.05,.14-.1,.24-.1,.14-.14,.24-.1,.14-.14,.24-.1,.14-.14,.24c-.05,.05-.1,.14-.14,.19-.05,.1-.1,.14-.14,.19s-.1,.14-.14,.19-.1,.14-.14,.19-.1,.14-.14,.19-.1,.14-.19,.19c-.05,.05-.1,.1-.19,.19-.05,.05-.14,.14-.19,.19s-.14,.1-.19,.14-.14,.1-.19,.19c-.05,.05-.14,.1-.19,.14s-.14,.1-.24,.14c-.05,.05-.14,.1-.19,.14-.1,.05-.14,.1-.24,.14-.05,.05-.14,.1-.19,.14-.05,0-.1,.05-.1,.05h-.05s-.05,.05-.1,.05c-.05,.05-.14,.05-.19,.1s-.1,.05-.19,.1c-.05,0-.1,.05-.14,.05s-.1,.05-.14,.05c-.1,.05-.19,.05-.24,.1-.05,0-.1,.05-.14,.05s-.05,0-.1,.05c-.14,.05-.33,.1-.48,.14l-1.86,2.48-1.86-2.48c-.19-.05-.33-.1-.48-.14-.03,0-.06-.02-.1-.05-.05,0-.1-.05-.14-.05-.1-.05-.19-.05-.29-.1-.05,0-.1-.05-.14-.05s-.1-.05-.14-.05c-.05-.05-.14-.05-.19-.1s-.1-.05-.19-.1c-.05,0-.1-.05-.14-.05h-.05s-.1-.05-.14-.05c.05-.1,0-.1-.1-.14s-.19-.1-.24-.14-.1-.1-.19-.14-.14-.1-.24-.19c-.05-.05-.1-.1-.19-.14s-.14-.14-.24-.19c-.05-.05-.1-.1-.14-.14s-.14-.14-.19-.19-.1-.1-.14-.14-.14-.14-.19-.19-.1-.1-.14-.19-.1-.14-.19-.24c-.05-.05-.1-.14-.14-.19-.05-.1-.1-.14-.14-.24-.05-.05-.1-.14-.14-.19-.05-.1-.1-.14-.14-.24-.05-.05-.1-.14-.1-.19-.05-.1-.1-.14-.14-.24-.05-.05-.05-.14-.1-.19-.05-.1-.1-.14-.1-.24-.05-.1-.1-.14-.1-.24-.05-.1-.05-.19-.1-.24-.05-.1-.05-.14-.1-.24v-.05h-.62s0,9.02,0,9.02Zm13.6-5.01h1.1v1.05h-1.1v-1.05Zm-3.15,2.43h4.25v1.05h-4.25s0-1.05,0-1.05Zm-9.26-2.43h1.1v1.05h-1.1v-1.05Zm0,2.43h4.25v1.05H5.22s0-1.05,0-1.05Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M11.48,5.22V3.08c-.57,.29-1.1,1.1-1.43,2.15h1.43Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M15.29,7.37c0,.38,0,.72-.05,1.05h1.1c.1-.33,.14-.72,.14-1.05,0-.38-.05-.72-.14-1.05h-1.1c0,.29,.05,.67,.05,1.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M8.95,5.22c.14-.57,.33-1.15,.62-1.57-.62,.38-1.15,.95-1.48,1.57h.86Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M11.48,11.62v-2.15h-1.43c.33,1.1,.86,1.86,1.43,2.15Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15.05,9.47c-.14,.57-.33,1.15-.62,1.57,.62-.38,1.15-.95,1.48-1.57h-.86Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M22.07,20.59V7.37h-2.43c0,.24,0,.48-.05,.76,0,.1,0,.19-.05,.29v.05h1.43v11.12H2.98V8.42h1.43v-.05c0-.1-.05-.19-.05-.29v-.72H1.93v13.22H22.07Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M12,.79c-3.44,0-6.35,2.67-6.58,6.11v.48c0,.24,0,.43,.05,.67,0,.1,0,.19,.05,.24,0,.14,.05,.24,.05,.38,.05,.1,.05,.24,.1,.33,.48,1.77,1.67,3.29,3.29,4.1h.05s.05,.05,.1,.05c.1,.05,.24,.1,.38,.14,.05,0,.1,.05,.14,.05,.1,.05,.24,.1,.33,.14,.05,0,.1,.05,.14,.05,.19,.05,.33,.1,.52,.14l.19,.05,1.24,1.67,1.24-1.67,.19-.05c.19-.05,.33-.1,.52-.14,.05,0,.1-.05,.14-.05,.14-.05,.24-.1,.33-.14,.05,0,.1-.05,.14-.05,.14-.05,.24-.1,.33-.14,.05,0,.1-.05,.1-.05,1.62-.86,2.82-2.34,3.29-4.1v-.05c.05-.1,.05-.24,.1-.33,.05-.14,.05-.29,.05-.38s.05-.14,.05-.24c0-.24,.05-.43,.05-.67v-.43c-.24-3.44-3.15-6.11-6.58-6.11Zm0,12.02c-3.05,0-5.49-2.43-5.49-5.49S8.95,1.88,12,1.88s5.49,2.43,5.49,5.49-2.43,5.44-5.49,5.44Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.15,6.27h-1.62v2.15h1.62c.05-.33,.1-.72,.1-1.05,0-.38-.05-.76-.1-1.1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.52,9.47v2.15c.57-.29,1.1-1.1,1.43-2.15h-1.43Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M8.95,9.47h-.86c.33,.67,.86,1.19,1.48,1.57-.24-.43-.48-1-.62-1.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalexpertise);
export default __webpack_public_path__ + "static/media/global expertise.9af2597421a37f09cc930ee77b742f8d.svg";
export { ForwardRef as ReactComponent };